import { useState, useEffect,useRef } from "react";
import useApiPrivate from "../../global/utils/hooks/useApiPrivate";
import { useNavigate, useLocation } from "react-router-dom";
import { useLogout } from "../../global/utils/hooks/useLogout";
import { Toast } from 'primereact/toast';

const USER_URL = 'api/v1/user';

export default function Users() {
    const [ users, setUsers ] = useState();

    const ApiPrivate = useApiPrivate();
    const navigate = useNavigate();
    const location = useLocation();
    const logout = useLogout();
    const toast = useRef(null);

    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }

    const signout = () => {
        logout();
    }

    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();

        const getUsers = async () => {

            try {
                const response = await ApiPrivate.get(USER_URL,{
                    signal: controller.signal
                });
                isMounted && setUsers(response.data);
            } catch (error) {
                if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
                    showError(error?.response?.data?.message);
                }  
                navigate('/login', { state: {form: location}, replace:true});
            }
        }
        getUsers();

        return () => {
            isMounted = false;
            controller.abort();
      };

    },[])
  return (
    <div>
        <Toast ref={toast} position="top-center" />

        <h2>user list</h2>
            {users 
                ? (
                    <h1>
                        {users.data.username}
                        <button onClick={signout}>logout</button>
                    </h1>
                ) :
                (
                    <p>No users to display</p>
                ) 
            }
    </div>
  )
}
